import Axios from 'axios';

//const BACKEND_URL = "http://localhost/colors-computer/api/";
const BACKEND_URL = "http://szerviz.colors-computer.hu/api/";
export default class {

    static getData(url){
        return Axios.get(BACKEND_URL + url);
    }

    static postData(url, data){
        return Axios.post(BACKEND_URL + url, data);
    }

    static putData(url, data){
        return Axios.put(BACKEND_URL + url, data);
    }

    static deleteData(url){
        return Axios.delete(BACKEND_URL + url);
    }

    static getPrintUrl(){
        return BACKEND_URL + 'print.php';
    }
}



// WEBPACK FOOTER //
// ./src/services/comm.js